<template>
	<div class="container">
		<div v-if="data.mode !== 'extended'" class="ratio ratio-21x9" v-html="data.iframe"></div>
		<div v-else class="row">
			<div class="col-12 col-lg-4">
				<template v-for="(marker,index) in this.data.markers">
					<div v-if="marker.title?.length > 0" class="w-100 p-3" :class="index !== 0 ? 'm-2' : 'mx-2' " style="background-color: #FFF;">
						<template v-if="marker.title">
							<div class="d-flex justify-content-between" @click="collapse(marker)">
								<h2 class="google-maps--title">{{ marker.title }} </h2>
								<h2 class="google-maps--title" v-if="!marker?.collapsed"><i class="fa-solid fa-plus"></i></h2>
							</div>
						</template>
						<template v-if="marker?.collapsed">
							<p class="p-3 mt-4" v-if="marker.address">
								<i class="fa-solid fa-thumbtack"></i> <a :href="'https://maps.google.com/?q='+marker.lat+','+marker.lng" target="_blank">{{ marker.address }}</a>
							</p>
							<p class="p-3" v-if="marker.email"><i class="fa-solid fa-envelope"></i> <a :href="'mailto:'+marker.email" target="_blank">{{ marker.email }}</a></p>
							<p class="p-3" v-if="marker.telephone"><i class="fa-solid fa-phone"></i> <a :href="'tel:'+marker.telephone" target="_blank">{{ marker.telephone }}</a></p>
							<hr v-if="marker.extraText">
							<p class="p-3" v-if="marker.extraText" v-html="marker.extraText"></p>
						</template>
					</div>
				</template>
			</div>
			<div class="col-12 col-lg-8">
				<div ref="googleMap" class="google-maps w-100"></div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import {GoogleMapsComponentInterface} from "../Interfaces/Components/GoogleMapsComponentInterface";
import GoogleMapsMixin from "../../../../Shared/Mixins/GoogleMapsMixin";
import {GoogleMapMarkerInterface} from "../Interfaces/Components/GoogleMapMarkerInterface";

export default defineComponent({
	name: "GoogleMapsComponent",
	mixins: [GoogleMapsMixin],
	components: {},
	props: {
		data: {
			type: Object as PropType<GoogleMapsComponentInterface>,
			default: [],
			required: true
		},
	},
	data() {
		return {
			map: null as google.maps.Map | null,
			collapsed: '',
		}
	},
	mounted() {
		this.initMap();
	},
	unmounted() {
		if (this.map) {
			google.maps.event.clearListeners(this.map, 'click');
		}
	},
	methods: {
		initMap() {
			const mapElement: HTMLElement | null = this.$refs.googleMap as HTMLElement;
			if (mapElement) {
				this.map = new google.maps.Map(mapElement, {
					center: {
						lat: Number(this.data?.center?.lat) ?? 47.4979,
						lng: Number(this.data?.center?.lng) ?? 19.0402
					},
					zoom: Number(this.data?.zoom) ?? 8,
					streetViewControl: false,
					mapTypeControl: false,
					mapTypeId: this.data?.mapType ?? google.maps.MapTypeId.SATELLITE,
					styles: this.googleMapStyles
				});
			}
			this.loadMarkers();

		},
		loadMarkers(): void {
			this.data?.markers?.forEach((element: GoogleMapMarkerInterface, index: number) => {
				const marker = new google.maps.Marker({
					position: {
						lat: Number(element.lat),
						lng: Number(element.lng),
					},
					map: this.map,
					icon: element.markerUrl ?? ''
				});


				const infoBox = new google.maps.InfoWindow({
					content: this.markerWindowDetails(element),
				});

				marker.addListener('click', () => {
					infoBox.open({
						anchor: marker,
						map: this.map,
						shouldFocus: false,
					});
					this.collapse(element);
				});
				if (index === 0) {
					this.collapse(element);
				}
			});

			if (this.map) {
				this.map.setCenter({
					lat: (Number(this.data?.center?.lat) ?? 47.4979),
					lng: (Number(this.data?.center?.lng) ?? 19.0402)
				});
				this.map.setZoom(Number(this.data?.zoom) ?? 8)
			}
		},
		collapse(marker: GoogleMapMarkerInterface): void {
			this.data.markers?.forEach(element => element.collapsed = false);
			const index = this.data.markers?.findIndex(element => element.id === marker.id);
			this.data.markers[index].collapsed = true;
			this.map?.setCenter({
				lat: Number(marker.lat),
				lng: Number(marker.lng),
			});
		}

	}
});
</script>

<style scoped>

:deep(.ratio) {
	border-radius: 10px;
	box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
	overflow: hidden;
}

:deep(.ratio iframe) {
	top: -60px;
	height: calc(100% + 60px);
}
</style>
